'use client';
import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import React from 'react';

type PublicHeaderProps = { serverAuthenticated?: boolean };

const PublicHeader = dynamic(
  () => import('@letsgo/PublicHeader').then((m: { PublicHeader?: ComponentType<PublicHeaderProps>; default?: ComponentType<PublicHeaderProps> }) => m.PublicHeader ?? m.default!),
  { ssr: true }
) as ComponentType<PublicHeaderProps>;

export default function ClientHeader({ serverAuthenticated = false }: { serverAuthenticated?: boolean }) {
  return <PublicHeader serverAuthenticated={serverAuthenticated} />;
}

